import React, { useRef } from 'react';
var VeltAutocompleteChipTooltip = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-autocomplete-chip-tooltip", { ref: ref }, children));
};
export default VeltAutocompleteChipTooltip;
